import React, { createContext, useState } from 'react';
export const FetchedCompanyLogoContext = createContext();
import PropType from "prop-types";

export const FetchCompanyLogo= ({ children }) => {
    const [companyLogo, setCompanyLogo] = useState(null);
    return (
        <FetchedCompanyLogoContext.Provider value={{companyLogo, setCompanyLogo}}>
            {children}
        </FetchedCompanyLogoContext.Provider>
    );
};

FetchCompanyLogo.propTypes= {
    children : PropType.node.isRequired
} 